import * as React from "react";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import {
    LoadComponentStateAsync,
    SaveComponentStateAsync,
} from "../../../../infrastructure/Data/MotwIndexedDb";
import { EPanelId } from "source/app/services/Shared/EPanelId";
import { NavMenuContainer } from "source/app/presentation/Shared/ActivePanel/NavigationMenu/Container/NavMenuContainer";

export class NavigationMenu extends React.Component<
    INavigationMenuProps,
    INavigationMenuState
> {
    constructor(props: INavigationMenuProps) {
        super(props);
		
        this.state = {
            lastBadgeUpdateTime: new Date().getTime(),
        };
    }

    async componentDidMount() {
        await LoadComponentStateAsync(this);
        State.ShareClass(ESharedComponent.NavigationMenu, this);
    }

    async componentDidUpdate() {
        await SaveComponentStateAsync(this);
        State.ShareClass(ESharedComponent.NavigationMenu, this);
    }

    render() {
        return (
            <NavMenuContainer activePanelTitle={this.props.activePanelTitle} />
        );
    }
}

export interface INavigationMenuState {
    lastBadgeUpdateTime: number;
}

interface INavigationMenuProps {
    activePanelTitle: EPanelId;
}
